export const SingleLine: React.FC = () => {
    return (
      <div className="w-[158px] h-[15px] relative animate-pulse">
        <div className="w-[100px] h-3 right-0  absolute bg-gray-300 rounded-[17px]" />
      </div>
    );
  }